var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEyeDisabled = function SvgIconEyeDisabled(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57149 3.75C5.3572 3.75 2.6122 5.74929 1.50006 8.57143C2.6122 11.3936 5.3572 13.3929 8.57149 13.3929C11.7858 13.3929 14.5308 11.3936 15.6429 8.57143C14.5308 5.74929 11.7858 3.75 8.57149 3.75ZM8.57149 11.7857C6.7972 11.7857 5.3572 10.3457 5.3572 8.57143C5.3572 6.79714 6.7972 5.35714 8.57149 5.35714C10.3458 5.35714 11.7858 6.79714 11.7858 8.57143C11.7858 10.3457 10.3458 11.7857 8.57149 11.7857ZM8.57149 6.64286C7.50435 6.64286 6.64292 7.50429 6.64292 8.57143C6.64292 9.63857 7.50435 10.5 8.57149 10.5C9.63863 10.5 10.5001 9.63857 10.5001 8.57143C10.5001 7.50429 9.63863 6.64286 8.57149 6.64286Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40771 13.5L15.4077 3",
    stroke: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEyeDisabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_eye_disabled.51209c96.svg";
export { ForwardRef as ReactComponent };